document.addEventListener('DOMContentLoaded', ()=> {

  window.scrollTo(0, 0);

  // Function to open and close video modal
  function toggleModal(modalID){
    document.getElementById(modalID).classList.toggle("hidden");
    document.getElementById(modalID + "-backdrop").classList.toggle("hidden");
    document.getElementById(modalID).classList.toggle("flex");
    document.getElementById(modalID + "-backdrop").classList.toggle("flex");
  }

  const images = document.querySelectorAll('.modal-toggle-activator');

  // Code to execute function and to get and add source and title to modal video
  if (images) {
    images.forEach((trigger)=>{
      trigger.addEventListener('click', ()=> {

        let videoSource = trigger.getAttribute('data-src');
        let videoTitle = trigger.getAttribute('data-title');
        const modalIframe = document.querySelector('#video-modal iframe');

        modalIframe.setAttribute('src', videoSource);
        modalIframe.setAttribute('title', videoTitle);
        document.querySelector('html').classList.toggle('overflow-hidden');
        setTimeout(()=> {
          toggleModal('video-modal');
        }, 500)

      })
    })
  }

  const desktopScreen = window.matchMedia("(min-width: 1024px)").matches;

  moveVideoToLastTimelineInfo();

  if (desktopScreen === true) {
    parallaxOnScroll();
  }

  // Animations on scroll initializer
  AOS.init();

  function parallaxOnScroll() {
    const classNames = {
      container: ".abi-history__timelineInfo",
      image: ".abi-history__timelinePrimaryImg",
      dlContainer: ".abi-history__timelineCard", // Selector to get container for datalayer
      year: ".abi-history__timelineYear", // Selector to get year for datalayer
    };
    const containers = Array.from(
      document.querySelectorAll(classNames.container)
    );
    const dlContainers = Array.from(
      document.querySelectorAll(classNames.dlContainer)
    )
    if (!containers.length) return;
    const throttleTime = 10;
    const containerInfo = containers.map((container, index) => {
      const offset = container.getBoundingClientRect();
      return {
        index,
        element: container,
        offset: {
          top: offset.top + window.scrollY,
          center: offset.top + window.scrollY + offset.height / 2,
          bottom: offset.top + window.scrollY + offset.height,
        },
        image: container.querySelector(classNames.image),
      };
    });
    const dlContainerInfo = dlContainers.map((dlContainer, index) => {
      const offset = dlContainer.getBoundingClientRect();
      return {
        index,
        element: dlContainer,
        offset: {
          top: offset.top + window.scrollY,
          center: offset.top + window.scrollY + offset.height / 2,
          bottom: offset.top + window.scrollY + offset.height,
        },
        year: dlContainer.querySelector(classNames.year),
        dlSent: false, // Key to save datalayer sent status
      };
    });

    hideImagesOnLoad(containerInfo);
    setInitialPosition();
    handleScrollRange();
    handleShowImages();

    function showOrHideImagesOnScroll (windowCenter, currentContainer) {

      // Get the first and last container
      const firstContainer = containerInfo[0];
      const lastContainer = containerInfo[containerInfo.length - 1];

      // First container
      if (windowCenter <= firstContainer.offset.bottom) {
        setCurrentContainer(currentContainer, firstContainer);
        currentContainer = firstContainer.index;
        toggleOpacity(firstContainer.image, 1);
      } else {
        toggleOpacity(firstContainer.image, 0);
      }
      // Last container
      if (windowCenter >= lastContainer.offset.top) {
        currentContainer = lastContainer.index;
        toggleOpacity(lastContainer.image, 1);
      } else {
        toggleOpacity(lastContainer.image, 0);
      }
      // All other containers
      if (containerInfo.length > 2) {
        const duplicatedContainers = [...containerInfo]; // Duplicate the array
        duplicatedContainers.pop(); // Remove the last item
        duplicatedContainers.shift(); // Remove the first item
        duplicatedContainers.forEach((container, index) => {
          const containerTop = container.offset.top;
          const containerBottom = container.offset.bottom;
          // If the window center is between the top and bottom of the container
          if (
            windowCenter >= containerTop &&
            windowCenter <= containerBottom
          ) {
            toggleOpacity(container.image, 1);
            currentContainer = container.index;
          } else {
            toggleOpacity(container.image, 0);
          }
        });
      }

    }

    function sendScrollDatalayers(windowCenter, dlCurrentContainer) {

      if (dlContainerInfo.length > 2) {
        dlContainerInfo.forEach((dlContainer) => {
          const containerTop = dlContainer.offset.top;
          const containerBottom = dlContainer.offset.bottom;
          // If the window center is between the top and bottom of the container
          if ( windowCenter >= containerTop && windowCenter <= containerBottom ) {
            dlCurrentContainer = dlContainer.index;

            if (dlContainer.dlSent === false) {
              dataLayer.push({
                'event':'GAEvent',
                'event_name':'history_change_year',
                'message_response':'show_year_info',
                'component_name':`history_content_${dlContainer.year.innerText}`,
                'element_text': dlContainer.year.innerText,
              });
              dlContainerInfo.forEach((el)=> {
                el.dlSent = false; // Reset datalayer sent status
              })
              dlContainer.dlSent = true;
            }

          }
        })
      }

    }

    function handleShowImages() {
      if (containerInfo.length < 2) return; // If there is only one container, don't do anything
      let currentContainer;
      let dlCurrentContainer;
      window.addEventListener(
        "scroll",
        throttle(() => {
          // Throttle the scroll event

          // Get the window center
          const windowCenter = window.scrollY + window.innerHeight / 2;

          // Timeline images function
          showOrHideImagesOnScroll(windowCenter, currentContainer)
          // Function to send scroll datalayers
          sendScrollDatalayers(windowCenter, dlCurrentContainer);

        }, throttleTime)
      );
    }
    function setCurrentContainer(last, current) {
      // const { index, image } = current;
      // if (last !== index) {
      //   const offsetX = image.getBoundingClientRect().left;
      //   console.log(offsetX);
      //   image.style.left = `${offsetX}px`;
      // }
    }
    function setInitialPosition() {
      const firstContainer = containerInfo[0];
      containerInfo.forEach(({ element }) => {
        element.style.height = `${element.offsetHeight}px`;
      });
      toggleOpacity(firstContainer.image, 1);
    }
    function handleScrollRange() {
      const firstContainer = containerInfo[0];
      const lastContainer = containerInfo[containerInfo.length - 1];
      const firstContainerCenter = firstContainer.offset.center;
      const lastContainerCenter = lastContainer.offset.center;
      window.addEventListener(
        "scroll",
        throttle(() => {
          const windowCenter = window.scrollY + window.innerHeight / 2;
          const windowBottom = window.scrollY + window.innerHeight;
          const windowTop = window.scrollY;
          if (
            windowCenter > firstContainerCenter &&
            windowCenter < lastContainerCenter
          ) {
            containerInfo.forEach(({ image }, index) => {
              toggleFixedStyles(image, true);
            });
          } else {
            containerInfo.forEach(({ image }, index) => {
              toggleFixedStyles(image, false);
            });
          }
        }, throttleTime)
      );
    }
  }
  function hideImagesOnLoad(containers) {
    containers.forEach(({ image }) => {
      toggleOpacity(image, 0);
      delete image.dataset['aos'];
    });
  }
  function toggleOpacity(element, opacity = 1) {
    if (!element) return;
    element.style.opacity = opacity;
  }
  function toggleFixedStyles(element, fixed = false) {
    if (!element) return;
    element.style.position = fixed ? "fixed" : "relative";
    element.style.transform = fixed ? `translateY(-50%)` : "none";
    element.style.top = fixed ? "50%" : "auto";
  }
  function throttle(func, wait) {
    let waiting = false;
    return function () {
      if (waiting) {
        return;
      }
      waiting = true;
      setTimeout(() => {
        func.apply(this, arguments);
        waiting = false;
      }, wait);
    };
  }


})
function moveVideoToLastTimelineInfo() {
  Array.from(document.querySelectorAll('.abi-history__timelineCard')).forEach((card) => {
    const video = card.querySelector('.abi-history__timelineVideo');

    if (video) {
      const infoList = Array.from(card.querySelectorAll('.abi-history__timelineInfo'));
      const lastInfo = infoList[infoList.length - 1];
      video.remove();
      lastInfo.appendChild(video);
    }

  })
}
